import { Link } from 'react-router';
import { Button } from '@/components/Button';

export function TodayNavigation() {
  return (
    <Button variant="outline" aria-label="Today" asChild size="sm">
      <Link to="/day">Today</Link>
    </Button>
  );
}
